import React from 'react';

import { basePageWrap } from '../BasePage/index';
import s from './ListItemPage.module.css';
import ContentBlocks from '../../components/blocks/ContentBlocks';
import Button from '../../components/Button';

import { ListItemPageProps } from '@/types/containers/listItemPage';

const ListItemPage = ({
    summaryImage,
    content,
    listOverview,
}: ListItemPageProps) => {
    const linkOverview = [
        {
            type: 'intern',
            value: listOverview.slug,
            id: listOverview.id,
        },
    ];
    return (
        <>
            <div className={s['ListItemPage']}>
                {summaryImage && (
                    <div
                        className={s.ListItemPage__keyvisual}
                        style={{
                            backgroundImage: `url("${summaryImage.img.src}")`,
                        }}>
                        <div className={s.ListItemPage__backButton}>
                            <Button
                                buttonLink={linkOverview}
                                buttonText={`Terug naar: ${listOverview.title}`}
                                buttonIcon="arrow_back"
                                buttonIconPosition="left"
                                buttonShowIcon="show_icon"
                            />
                        </div>
                    </div>
                )}
                <div className="">
                    <ContentBlocks content={content} />
                </div>
            </div>
        </>
    );
};

export default basePageWrap(ListItemPage);
